<template>
  <div class="panel-redirect">
    <div class="redirect-content">
      <h2>Yönlendiriliyor...</h2>
      <div class="loading-spinner"></div>
      <p>Lütfen bekleyin...</p>
    </div>
  </div>
</template>

<script>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

export default {
  name: 'PanelRedirect',
  setup() {
    const router = useRouter()

    onMounted(() => {
      // Kısa bir gecikme ile yönlendirme yap (UX için)
      setTimeout(() => {
        redirectBasedOnRole()
      }, 1000)
    })

    const redirectBasedOnRole = () => {
      const userStr = localStorage.getItem('user')
      
      if (!userStr) {
        
        router.push('/login')
        return
      }
      
      try {
        const userData = JSON.parse(userStr)
        
        
        switch (userData.role) {
          case 'ogrenci':
            router.push('/panel/ogrenci')
            break
          case 'hoca':
            router.push('/panel/hoca')
            break
          case 'admin':
            router.push('/panel/admin')
            break
          default:
            
            router.push('/login')
            break
        }
      } catch (error) {
        console.error('❌ PanelRedirect: JSON parse hatası:', error)
        router.push('/login')
      }
    }

    return {}
  }
}
</script>

<style scoped>
.panel-redirect {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.redirect-content {
  text-align: center;
  background-color: white;
  padding: 3rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #4CAF50;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 1rem auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

h2 {
  color: #333;
  margin-bottom: 1rem;
}

p {
  color: #666;
  margin-top: 1rem;
}
</style>
